/**
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html, nothing } from 'lit';
import { SHARED_STYLES } from '../css/shared-css.js';
import { customElement, property } from 'lit/decorators.js';
let ChromedashBanner = class ChromedashBanner extends LitElement {
    constructor() {
        super(...arguments);
        this.timestamp = null; // Unix timestamp: seconds since 1970-01-01.
        this.message = '';
    }
    static get styles() {
        return [
            ...SHARED_STYLES,
            css `
        div {
          display: inline-block;
          background: var(--warning-background);
          color: var(--warning-color);
          border-radius: var(--border-radius);
          padding: var(--content-padding);
          width: 100%;
        }
      `,
        ];
    }
    computeLocalDateString() {
        if (!this.timestamp) {
            return nothing;
        }
        const date = new Date(this.timestamp * 1000);
        const formatOptions = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        }; // No seconds
        return date.toLocaleString(undefined, formatOptions);
    }
    render() {
        if (!this.message) {
            return nothing;
        }
        return html ` <div>${this.message} ${this.computeLocalDateString()}</div> `;
    }
};
__decorate([
    property({ type: Number })
], ChromedashBanner.prototype, "timestamp", void 0);
__decorate([
    property({ type: String })
], ChromedashBanner.prototype, "message", void 0);
ChromedashBanner = __decorate([
    customElement('chromedash-banner')
], ChromedashBanner);
